
define( 'FORCES_AND_MOTION_BASICS/../nls/mk/forces-and-motion-basics-strings',{
          "none": "без",
          "force": "Сила",
          "values": "вредности",
          "frictionTitle": "Триење",
          "redWins": "Црвените победија!",
          "frictionForce": "Сила на триење",
          "pause": "Пауза",
          "friction": "Триење",
          "forces-and-motion-basics.name": "Сили и движење - Основи",
          "appliedForce": "Применета сила",
          "leftForce": "сила налево",
          "rightForce": "сила надесно",
          "sound": "звук",
          "lots": "многу",
          "forces": "Сили",
          "motion": "Движење",
          "tugOfWar": "Влечење со јаже",
          "go": "Старт!",
          "newtons.n": "њутни (N)",
          "sumOfForcesEqualsZero": "збир на сили  = 0",
          "blueWins": "Сините победија!",
          "speed": "брзина",
          "sumOfForces": "збир на сили",
          "return": "Почеток",
          "translation.credits": "Зоран Христовски",
          "newtons": "њутни",
          "masses": "Маси"
        } );